import { AnchorHTMLAttributes, FunctionComponent } from "react";

import * as styles from "./GroupItem.css";

type Props = AnchorHTMLAttributes<HTMLAnchorElement>;

const GroupItem: FunctionComponent<Props> = ({ className, ...props }) => {
  return (
    <li className={className}>
      <a {...props} className={styles.subMenuLink}>
        {props.children}
      </a>
    </li>
  );
};

export default GroupItem;
